import React from 'react'

const Counters = props => {
  return (
    <section className="g-brd-top g-brd-bottom g-brd-gray-light-v4 g-pt-50">
        <div className="container">
          <div className="row text-center text-uppercase">
            <div className="col-lg-3 col-sm-6 g-brd-right g-brd-gray-light-v4 g-mb-50">
              <div className="js-counter g-color-gray-dark-v2 g-font-size-35 g-font-weight-300 g-mb-7">52147</div>
              <h4 className="h6 g-color-gray-dark-v5">Code Lines</h4>
            </div>

            <div className="col-lg-3 col-sm-6 g-brd-right--lg g-brd-gray-light-v4 g-mb-50">
              <div className="js-counter g-color-gray-dark-v2 g-font-size-35 g-font-weight-300 g-mb-7">24583</div>
              <h4 className="h6 g-color-gray-dark-v5">Projects</h4>
            </div>

            <div className="col-lg-3 col-sm-6 g-brd-right g-brd-gray-light-v4 g-mb-50">
              <div className="js-counter g-color-gray-dark-v2 g-font-size-35 g-font-weight-300 g-mb-7">7348</div>
              <h4 className="h6 g-color-gray-dark-v5">Working Hours</h4>
            </div>

            <div className="col-lg-3 col-sm-6 g-mb-50">
              <div className="js-counter g-color-gray-dark-v2 g-font-size-35 g-font-weight-300 g-mb-7">87904</div>
              <h4 className="h6 g-color-gray-dark-v5">Job Offers</h4>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Counters
